import { ShortTermHousingRentals } from './components';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return <ShortTermHousingRentals />;
}

export default App;
